// function getCssValuePrefix() {
//   let rtrnVal = '';
//   const prefixes = ['-o-', '-ms-', '-moz-', '-webkit-'];

//   // Create a temporary DOM object for testing
//   const dom = document.createElement('div');

//   for (let i = 0; i < prefixes.length; i += 1) {
//     // Attempt to set the style
//     dom.style.background = `${prefixes[i]}linear-gradient(#000000, #ffffff)`;
//     // Detect if the style was successfully set
//     if (dom.style.background) {
//       rtrnVal = prefixes[i];
//     }
//   }
//   return rtrnVal;
// }

// const BrowserPrefix = getCssValuePrefix();

function HTMLCollectionToArray(col) {
  const ar = [];
  for (let i = 0, count = col.length; i < count; i += 1) {
    ar.push(col.item(i));
  }
  return ar;
}

function getChildElements(parent, tag) {
  const ar = [];
  for (let i = 0, count = parent.length; i < count; i += 1) {
    const node = parent.item(i);
    if ((node.nodeType === Node.ELEMENT_NODE) && (!tag || (tag === node.tagName))) {
      ar.push(node);
    }
  }
  return ar;
}

function findDocumentElement(path) {
  let result = path.reduce((curElt, pathElt) => {
    if (pathElt[0] === '#') {
      return [document.getElementById(pathElt.substring(1))];
    }
    if (pathElt[0] === '.') {
      const className = pathElt.substring(1);
      return (curElt || [document]).map(elt => HTMLCollectionToArray(elt.getElementsByClassName(className))).flat();
    }
    return (curElt || [document.documentElement]).map(elt => getChildElements(elt, pathElt)).flat();
  }, null);
  result = result.filter(e => e);
  return result.length ? result[0] : null;
}

function isHidden(el) {
  if (!el) return true;
  const style = window.getComputedStyle(el);
  return style.display === 'none';
}

function isVisible(el) {
  if (!el) return false;
  const style = window.getComputedStyle(el);
  return style.display !== 'none';
}

export { findDocumentElement, getChildElements, HTMLCollectionToArray, isHidden, isVisible };
